import React, { useEffect, useRef, useState } from "react";
import { Grid, Typography, Divider, Card } from "@mui/material";
import Layout from "../../../layout/Layout";
import "../../../assets/css/dashboard.css";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import UserAvatar from "../../../components/UserAvatar";
import DashboardCard from "../../../components/DashboardCard";
import { Box } from "@mui/system";
import { config, userDashboardAPI, userData } from "../../../config";
import axios from "axios";

function Dashboard() {
  const [dashboardCardList, setDashboardCardList] = useState([]);
  // const dashboardCardList = [
  //   {
  //     count: 3,
  //     title: "Unresolved",
  //   },
  //   {
  //     count: 5,
  //     title: "Overdue",
  //   },
  //   {
  //     count: 7,
  //     title: "Due today",
  //   },
  //   {
  //     count: 2,
  //     title: "Open",
  //   },
  //   {
  //     count: 0,
  //     title: "On hold",
  //   },
  // ];

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      const data = JSON.stringify({
        intUserID: userData.id,
        intSPType: 1
      });
      config.method = "PATCH";
      config.data = data;
      config.url = userDashboardAPI;
      axios(config)
        .then(function (response) {
          setDashboardCardList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const [checked, setChecked] = React.useState([0]);

  const handleToggle1 = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <Layout>
      <Grid container spacing={4}>
        {dashboardCardList.map((row, id) => (
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} key={id}>
            <DashboardCard title={row.title} count={row.count} />
          </Grid>
        ))}
      </Grid>

      {/* <Grid container spacing={4} padding="20px">
        <Grid item xs={12} md={6} lg={6}>
          <Typography fontWeight="600" variant="h6">
            Last 24 Hours
          </Typography>
          <br />
          {data.map((row, id) => (
            <div key={id}>
              <ListItem className="list-grid">
                <UserAvatar name={row.ticketCreatedUserName} />

                <Grid>
                  <Typography className={`ticket-type ${row.ticketType}`}>
                    {row.ticketType}
                  </Typography>
                  <Typography className="ticket-title">
                    {row.ticketSubject}#{row.ticketID}
                  </Typography>
                  <Typography className="ticket-details">
                    {row.ticketCreatedUserName}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      className="app-icon app-icon--micro"
                    >
                      <path d="M27.733 16c0 6.48-5.253 11.733-11.733 11.733S4.267 22.48 4.267 16 9.52 4.267 16 4.267 27.733 9.52 27.733 16z"></path>
                    </svg>
                    {row.ticketCreatedAt}
                  </Typography>
                </Grid>

                <Grid>
                  <Typography className="ticket-details">
                    Category{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      className="app-icon app-icon--micro"
                    >
                      <path d="M27.733 16c0 6.48-5.253 11.733-11.733 11.733S4.267 22.48 4.267 16 9.52 4.267 16 4.267 27.733 9.52 27.733 16z"></path>
                    </svg>{" "}
                    {row.ticketCategory}
                  </Typography>
                  <Typography className="ticket-details">
                    Status{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      className="app-icon app-icon--micro"
                    >
                      <path d="M27.733 16c0 6.48-5.253 11.733-11.733 11.733S4.267 22.48 4.267 16 9.52 4.267 16 4.267 27.733 9.52 27.733 16z"></path>
                    </svg>{" "}
                    {row.ticketStatus}
                  </Typography>
                </Grid>
              </ListItem>
              <Divider className="list-divider" />
            </div>
          ))}
        </Grid>
      </Grid> */}

      <div className="empty-space-20"></div>

      {/* <Grid container spacing={4}>
        <Grid item xs={12} lg={6} md={6} className={`dashboard-outter-card`}>
          <Card className={`dashboard-1-card`}>
            <Grid>
              <Typography className={`text--dark text--medium`}>
                Customer satisfaction
              </Typography>
              <Typography className={`text--xsmall text--gray`}>
                Across helpdesk this month
              </Typography>
            </Grid>
            <div className="empty-space-30"></div>
            <Grid container>
              <Grid item xs={12} lg={6} md={6}>
                <Typography className={`text--dark text--medium`}>
                  Responses received
                </Typography>
                <div className="empty-space-20"></div>
                <Typography
                  variant="h5"
                  fontWeight={`600`}
                  className={`text--chateau`}
                >
                  0
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <Typography className={`text--dark text--medium`}>
                  Positive
                </Typography>
                <div className="empty-space-20"></div>
                <Grid display={`flex`} alignItems="center" gap="50px">
                  <Typography
                    variant="h5"
                    fontWeight={`600`}
                    className={`text--chateau`}
                  >
                    0%
                  </Typography>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="28"
                    viewBox="0 0 60 60"
                    className="app-icon app-icon--xlarge align-middle"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#6BB437"
                        fillOpacity=".3"
                        stroke="#6BB437"
                        strokeWidth="4.56"
                        d="M56 29.5C56 14.864 44.136 3 29.5 3S3 14.864 3 29.5 14.864 56 29.5 56 56 44.136 56 29.5"
                      ></path>
                      <path
                        stroke="#6BB437"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4.56"
                        d="M40.857 38.964c-7.571 5.679-15.143 5.679-22.714 0"
                      ></path>
                      <path
                        fill="#6BB437"
                        d="M43.696 23.729a4.732 4.732 0 10-9.464 0 4.732 4.732 0 009.464 0m-18.928 0a4.732 4.732 0 10-9.464 0 4.732 4.732 0 009.464 0"
                      ></path>
                    </g>
                  </svg>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <Typography className={`text--dark text--medium`}>
                  Neutral
                </Typography>
                <div className="empty-space-20"></div>
                <Grid display={`flex`} alignItems="center" gap="50px">
                  <Typography
                    variant="h5"
                    fontWeight={`600`}
                    className={`text--chateau`}
                  >
                    0%
                  </Typography>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="28"
                    viewBox="0 0 60 60"
                    className="app-icon app-icon--xlarge align-middle"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#FFD012"
                        fillOpacity=".3"
                        stroke="#FFD012"
                        strokeWidth="4.56"
                        d="M56 29.693c0-14.691-11.864-26.6-26.5-26.6S3 15.002 3 29.693c0 14.692 11.864 26.6 26.5 26.6S56 44.385 56 29.693"
                      ></path>
                      <path
                        stroke="#FFD012"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4.56"
                        d="M37.071 41H21.93"
                      ></path>
                      <path
                        fill="#FFD012"
                        d="M43.696 23.9c0-2.624-2.117-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.615 0 4.732-2.128 4.732-4.75m-18.928 0c0-2.624-2.118-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.614 0 4.732-2.128 4.732-4.75"
                      ></path>
                    </g>
                  </svg>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <Typography className={`text--dark text--medium`}>
                  Negative
                </Typography>
                <div className="empty-space-20"></div>
                <Grid display={`flex`} alignItems="center" gap="50px">
                  <Typography
                    variant="h5"
                    fontWeight={`600`}
                    className={`text--chateau`}
                  >
                    0%
                  </Typography>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="28"
                    viewBox="0 0 60 60"
                    className="app-icon app-icon--xlarge align-middle"
                  >
                    <g fill="#FF5959" fillRule="evenodd">
                      <path
                        fillOpacity=".3"
                        stroke="#FF5959"
                        strokeWidth="4.56"
                        d="M56 29.693c0-14.691-11.864-26.6-26.5-26.6S3 15.002 3 29.693c0 14.692 11.864 26.6 26.5 26.6S56 44.385 56 29.693"
                      ></path>
                      <path
                        fillRule="nonzero"
                        d="M16.327 41.214c6.283-8.392 20.063-8.392 26.346 0a2.286 2.286 0 01-.451 3.192 2.266 2.266 0 01-3.18-.453c-4.466-5.964-14.618-5.964-19.083 0a2.266 2.266 0 01-3.18.453 2.286 2.286 0 01-.452-3.192z"
                      ></path>
                      <path d="M43.696 23.9c0-2.624-2.117-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.615 0 4.732-2.128 4.732-4.75m-18.928 0c0-2.624-2.118-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.614 0 4.732-2.128 4.732-4.75"></path>
                    </g>
                  </svg>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} lg={6} md={6} className={`dashboard-outter-card`}>
          <Card className={`dashboard-1-card`}>
            <Grid>
              <Typography className={`text--dark text--medium`}>
                To-do
              </Typography>
            </Grid>
          </Card>
        </Grid>
      </Grid> */}
    </Layout>
  );
}

export default Dashboard;
